import React from "react";

interface EmptyProductsViewProps {
  onAddProduct: () => void;
}

export const EmptyProductsView: React.FC<EmptyProductsViewProps> = ({
  onAddProduct,
}) => {
  return (
    <div className="w-full py-6 flex flex-col justify-start items-center gap-6">
      <div className="w-40 h-40 flex items-center justify-center">
        <img
          src="/icons/empty_products.svg"
          alt="No products"
          className="w-32 h-32"
          onError={(e) => {
            e.currentTarget.src =
              "https://placehold.co/128x128?text=No+Products";
          }}
        />
      </div>
      <div className="self-stretch text-center justify-start text-[#6F6F6B] text-sm font-normal font-sora leading-none">
        Bạn chưa có sản phẩm nào
      </div>

      <div
        data-hierarchy="primary"
        data-show-icon-line-left="true"
        data-show-icon-line-right="false"
        data-size="medium"
        className="px-4 py-3.5 bg-[#E06448] rounded-full inline-flex justify-center items-center gap-2.5 cursor-pointer"
        onClick={onAddProduct}
      >
        <div className="size-5 relative overflow-hidden">
          <div className="size-3 left-[4.38px] top-[4.38px] absolute bg-[#F4E7DA]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M6 3V9M3 6H9"
                stroke="#F4E7DA"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="text-center justify-start text-[#F4E7DA] text-sm font-medium font-sora leading-none">
          Thêm sản phẩm
        </div>
      </div>
    </div>
  );
};

export default EmptyProductsView;
